export default __webpack_public_path__ + "78e7c77be0cccfce25c7ac4899b0183b.png";